import * as React from 'react'
import * as ReactDOMServer from 'react-dom/server';
import { AsyncState } from 'widgets-for-react';

export const slugify: (str: string) => string = (str: string) =>
  str
    ? str
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '')
    : ''

export const camelize = (text: string) => {
  text = text.replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
  return text.substr(0, 1).toLowerCase() + text.substr(1);
}

export const capitalize = (text: string) => text ? text[0].toUpperCase() + text.slice(1) : ''

export function convertReactNodeToString(title: React.ReactNode): string {
  if (title === undefined) return '';
  if (typeof title === 'string') return title;

  if (typeof title === 'number' || typeof title === 'boolean') {
    return title.toString();
  }

  if (React.isValidElement(title)) {
    let flatTitle: string = ReactDOMServer.renderToStaticMarkup(title);
    flatTitle = flatTitle.replace(/(<([^>]+)>)/ig, '');
    return flatTitle;
  }

  return ''
}

export function getClassName<Style>(
  style: Style | undefined,
  className: keyof Style,
  notset: string = ''
): string {
  return style ? String(
      style[className]
        ? style[className]
        : notset
    ) : notset
}

export const convertRemToPx = (rem: string | number) => {
  const remValue = typeof rem == 'string' ? parseFloat(rem) : rem
  return parseFloat(getComputedStyle(document.documentElement).fontSize) * remValue
}
export const convertPxToRem = (px: number) =>
  px / parseFloat(getComputedStyle(document.documentElement).fontSize)

export function htmlDecode(input: string) {
  try {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent
  } catch (e) {
    console.error(e)
    return input
  }
}

export function unEntity(str: string) {
  str = str || ""
  return str.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
}

export const getFileType = (link: string): string => {
  const ext: string = link.split('.').pop() || ''
  return ext;
}

export const displayUTCTime = (date: Date) => `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}`

export const previousOrDefault = <A>(asyncState: AsyncState<A>, defaultValue: A) => asyncState.kind == 'loaded' ? asyncState.value : defaultValue

export const ready =
  <A>(asyncState: AsyncState<A>): asyncState is AsyncState<A> & { kind: 'loaded' | 'loading' } =>
    asyncState.kind == 'loaded' || asyncState.kind == 'loading'